import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["content"],
  _excluded2 = ["content"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Plugin } from 'prosemirror-state';
import pluginKey from './pluginKey';
import { uploadFromClipboard, uploadDroppedFiles, uploadPastedFiles } from './actions';
import { media } from './nodes/media';
import './Media.scss';
import EditorReactView from '../../utils/EditorReactView';
import MediaView from './MediaView';
import { isEmpty } from '../../../../utils/helper';
import { DEFAULT_ALLOWED_DOMAINS_FOR_MEDIA_UPLOAD } from '../../utils/constants';
const getMediaPosition = state => {
  const mediaNode = state.schema.nodes.media;
  const node = state.doc.nodeAt(state.selection.$from.pos);
  return node && node.type === mediaNode ? state.selection.$from.pos : null;
};
export default {
  name: 'media',
  defaultOptions: {
    inline: true,
    allowedOrigins: DEFAULT_ALLOWED_DOMAINS_FOR_MEDIA_UPLOAD
  },
  configure: (options, activePlugins) => ({
    nodes: {
      media
    },
    menuItems: [],
    plugin: new Plugin({
      key: pluginKey,
      state: {
        init: (_, state) => ({
          pos: getMediaPosition(state)
        }),
        apply: (tr, pluginState, _oldState, newState) => {
          if (tr.docChanged || tr.selectionSet) {
            const newPluginState = _objectSpread(_objectSpread({}, pluginState), {}, {
              pos: getMediaPosition(newState)
            });
            return newPluginState;
          }
          return pluginState;
        }
      },
      props: {
        nodeViews: {
          media: (node, view, getPos) => new EditorReactView(MediaView, {}, node, view, getPos, 'inline-block', options)
        },
        handlePaste: (view, event, slice) => {
          const _ref = slice.toJSON() || {},
            {
              content
            } = _ref,
            restSlice = _objectWithoutProperties(_ref, _excluded);
          if (isEmpty(content)) return uploadFromClipboard(view, event, options);
          uploadPastedFiles(view, event, options, content, restSlice);
          return true;
        },
        handleDrop: (view, event, slice) => {
          const _ref2 = slice.toJSON() || {},
            {
              content
            } = _ref2,
            restSlice = _objectWithoutProperties(_ref2, _excluded2);
          if (isEmpty(content)) return uploadDroppedFiles(view, event, options);
          uploadPastedFiles(view, event, options, content, restSlice);
          return true;
        }
      }
    })
  })
};